export default __webpack_public_path__ + "static/media/collapse_icon.61172e10.svg";